<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">Customer Delivery Order  
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="print">Print DO</b-button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
          <b-input-group >
              <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
              <b-input-group-prepend><span class="p-2">Customer</span></b-input-group-prepend>
              <b-form-input  v-model="tblData.CustName" @change="customerChange"></b-form-input>
              <b-input-group-append>
              <b-btn text="Button" @click="lkuCustomerShow=true" >
                  <i class="fa fa-search"></i>
              </b-btn>
              </b-input-group-append>
          </b-input-group>
          <b-input-group >
            <b-input-group-prepend><label>Delivery Date</label></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
            <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
          </b-input-group>
        </b-col>
        <b-col  lg="5">
            <b-input-group >
              <b-input-group-prepend><label>Item</label></b-input-group-prepend>
              <b-form-input v-model="tblData.itemname" placeholder="Item Name" @change="itemChange"></b-form-input>
                <b-input-group-append>
                <b-btn text="Button" @click="lkuItemShow=true" >
                    <i class="fa fa-search"></i>
                </b-btn>
                </b-input-group-append>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>Customer Group</label></b-input-group-prepend>
                <b-form-select v-model="tblData.customer_group" :plain="true" :options="customerGroups" ></b-form-select>
                <b-input-group-append><b-button class="btn btn-success ml-3 mr-1" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button></b-input-group-append>
                <b-input-group-append><b-button class="btn btn-secondary" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button></b-input-group-append>
            </b-input-group>
        </b-col>
        </b-row>                      

        <b-table
        class="mb-0"
            ref="tblVendor"
            responsive
            striped hover 
            style="font-size:smaller;"
            :items="data"
            :fields="fields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"
            :key="tblData.limit" 
            @row-clicked="selectItem"
          >
            <template v-slot:cell(tanggal)="data">
              {{ data.item.tanggal | moment("DD MMM YYYY") }}
            </template>

            <template v-slot:cell(unitprice)="data">
             <span v-if="(data.item.unitprice)">{{uanguser}} {{data.item.unitprice | numFormat}}</span>
            </template>
            <template v-slot:cell(qtyOrder)="data">
             <span v-if="(data.item.qtyOrder)">{{data.item.qtyOrder | numFormat}}</span>
            </template>
            <template v-slot:cell(qtyChecker)="data">
             <span v-if="(data.item.qtyChecker)">{{data.item.qtyChecker | numFormat}}</span>
            </template>
          <template v-slot:cell(action)="data">
            <div class="text-center">
            <a href="javascript:void(0)" @click="edit(data.item)">
              <i class="fa fa-pencil"></i>
            </a>
            |
            <a href="javascript:void(0)" class="text-danger" @click="deleteConfirm(data.item)">
              <i class="fa fa-trash"></i>
            </a>
            </div>
          </template>
          </b-table>
      <b-row>
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total | numFormat}} entries
          </div>
        </b-col>
        <b-col cols="2" >
          <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
          </b-input-group>
        </b-col>        
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>



    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
        <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true">
            <lku-customer @click="onSelectLkuCustomer"></lku-customer>
        </b-modal>        
        <b-modal v-model="lkuItemShow" size="lg" :hide-footer="true" title="List of Master Item" :centered="true">
            <lku-item @click="onSelectLkuItem"  jasa="0" isactive="1" :formdata="itemList" ></lku-item>
        </b-modal>        

  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, decimal } from "vuelidate/lib/validators";
import moment from 'moment';
import bakerydo from "../../apis/bakerycustomerdelivery";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import myNumber from "../../components/my-number";
import lkuCustomer from "../lookup/lkuCustomer";
import lkuItem from "../lookup/lkuItemLazzy";
import toastr from "mini-toastr";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
        frmdata: {
            itemno: { required },
            unitprice: { required, decimal },
            customer_id: { required },
        },
  },   
  data() {
    return {
      fields: [
          {
            key: "nomor_do",
            thStyle: "width:100px",
            label: "DO Number",
            sortable: true
          },
          {
            key: "tanggal",
            thStyle: "width:90px",
            label: "DO Date",
            sortable: true
          },
          {
            key: "CustCode",
            label: "Customer Code",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "CustName",
            label: "Customer Name (and Group)",
            sortable: true
          },
          {
            key: "itemname",
            label: "Item Name",
            sortable: true
          },
          {
            key: "partnumber",
            label: "Item Code",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "unitsize",
            thStyle: "width:80px",
            label: "Order UnitSize",
            thClass: "text-center",
            tdClass: "text-center"
          },
          {
            key: "unitprice",
            tdClass: "text-right",
            label: "Sale Price",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "qtyOrder",
            tdClass: "text-right",
            label: "Qty.Order",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "qtyDeliver",
            tdClass: "text-right",
            label: "Qty. Deliver",
            thStyle: "width:100px",
            sortable: true
          },
      ],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'CustName',
        sortDesc: false,
        headcategory:null,
        tgl1:'',
        tgl2:''
      },
      items:[],
      model:{},showFrm:false,
      frmdata: {unitprice:0, itemno:'', customer_id:''},
      // frmdata: {unitprice:0, itemno:'', customer_id:'',Bill2CustNo:'',},
      lkuItemShow:false,
      itemList:{},
      lkuCustomerShow:false,
        uanguser: this.$store.state.user.matauang,
      isLoading:false,
      showDelConfirm: false,
      showFilter:false,
      showList:true,
      showReport:false,
      reportUrl: `${location.origin}/#load`,
        activeStatus : [{ value: '', text: '-- ALL --' },, { value: '0', text: 'Discontinued' },{ value: '1', text: 'Active/In Use' }],
      customerGroups:[{value:'', text:'--ALL--'},{value:'RETAIL', text:'RETAIL'}, {value:'WHOLESHALE', text:'WHOLESHALE'}],
      headCategories:[], itemCategories:[]
    };
  },
  computed: {
    invalidFrmdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },

  },  
  components :{Loading,lkuCustomer, lkuItem, myNumber},
  methods: {
    data: async function(ctx) {
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.itemlist) {
            this.tblData[key] = filter.itemlist[key];
            filtered=true;
        }
        if (filtered === true) {
          this.showFilter=filtered;
          delete filter.itemlist;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
        }
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading = true;
      let list = await bakerydo.list(this.tblData);
      this.items=list;
      this.lkuLoading = false;
      return list;  
    },
    selectItem(record,index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    refresh() {
      this.$refs.tblVendor.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    clearFilter(ctx) {
        this.tblData.itemno = '';
        this.tblData.itemname =  '';
        this.tblData.customer_id = '';
        this.tblData.CustName =  '';
        this.refresh();
    },    
    itemChange: function () {
        this.tblData.itemno = '';
    },
    customerChange: function () {
        this.tblData.customer_id = '';
    },        
    // add: function(data) {
    //       this.frmdata.customer_id= '';
    //       this.frmdata.CustCode= '';
    //       this.frmdata.CustName= '';
    //       this.frmdata.customer= '';
    //       this.frmdata.itemno= '';
    //       this.frmdata.itemcode= '';        
    //       this.frmdata.itemname= '';
    //       this.frmdata.partnumber= '';
    //       this.frmdata.tablekey= '';
    //       this.showFrm=true;
    // },
    // edit: function() {
    //     if (this.model) {
    //       this.frmdata.tablekey= this.model.tablekey;
    //       this.frmdata.customer_id= this.model.customer_id;
    //       this.frmdata.CustCode= this.model.CustCode;
    //       this.frmdata.CustName= this.model.CustName;
    //       this.frmdata.customer= `${this.model.CustName} | ${this.model.CustCode}`;
    //       this.frmdata.itemno= this.model.itemno;
    //       this.frmdata.itemcode= this.model.itemcode;
    //       this.frmdata.itemname= this.model.itemname;
    //       this.frmdata.partnumber= this.model.partnumber;
    //       this.frmdata.unitsize= this.model.unitsize;
    //       this.frmdata.unitprice= this.model.unitprice;

    //       this.showFrm=true;
    //     } else {
    //         toastr.warn('Please select a row that want to be Edit!');
    //     }
    // },
    onSelectLkuItem: function (lkuData) {
        this.itemList=lkuData;
        this.lkuItemShow=false;
        this.tblData.itemno = lkuData.selected.itemno;
        this.tblData.itemname = lkuData.selected.itemname;
        this.frmdata.itemno = lkuData.selected.itemno;
        this.frmdata.itemname = lkuData.selected.itemname;
        this.frmdata.partnumber = lkuData.selected.partnumber;
        this.frmdata.unitsize = lkuData.selected.unitsize;
        this.frmdata.unitprice = lkuData.selected.unitprice;
    },
    onSelectLkuCustomer: async function (_selected) {
        // untuk filter
        this.tblData.customer = _selected.CustName.trim();
        this.tblData.customer_id = _selected.customer_id;
        this.tblData.CustCode = _selected.CustCode;
        this.tblData.CustName = _selected.CustName;

        // untuk set data form
        this.frmdata.customer_id = _selected.customer_id;
        this.frmdata.CustCode = _selected.CustCode;
        this.frmdata.CustName = _selected.CustName;
        this.frmdata.customer = `${_selected.CustName} | ${_selected.CustCode}`;
        //this.frmdata.Bill2CustNo = _selected.Bill2CustNo;
        this.lkuCustomerShow=false;
    },    
  //   save: async function(evt) {
  //     evt.preventDefault()
  //     if (this.invalidFrmdata) {
  //         console.log('validation : ', this.$v.frmdata);
  //         console.log('frmdata obj : ',this.frmdata);
  //         toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
  //     } else {
  //       try {
  //         this.showFrm = false;
  //         await bakerydo.save(this.frmdata);
  //         this.refresh();          
  //       } catch (error) {
  //         this.showFrm = true;
  //               console.log('error : ', error);
  //               if (error.sql) {
  //                   toastr.error(error.sql,'ERROR MESSAGE',10000);
  //               } else if (error.sqlMessage) {
  //                   toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
  //               } else if (error.message) {
  //                   toastr.error(error.message,'ERROR MESSAGE',10000);
  //               } else {
  //                   toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
  //               }            
  //       }
  //     }
  // },
    // deleteConfirm() {
    //     if (this.model) {
    //       this.showDelConfirm = true;
    //     } else {
    //         toastr.warn('Please select a row that want to be Delete!');
    //     }
    // },
    // deleteData: async function() {
    //   try {
    //     this.isLoading=true;
    //     await bakerydo.remove(this.model);
    //   this.refresh();
    //     // const index= this.items.findIndex(r => (r.itemno==this.model.itemno));
    //     // this.items.splice(index, 1);
    //     this.isLoading=false;
    //   } catch (error) {
    //             if (error.sql) {
    //                 toastr.error(error.sql,'ERROR MESSAGE',10000);
    //             } else if (error.sqlMessage) {
    //                 toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
    //             } else if (error.message) {
    //                 toastr.error(error.message,'ERROR MESSAGE',10000);
    //         } else {
    //             toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
    //         }        
    //   }
    // },
    print: async function()
    {
      if (this.model.tablekey) {
          this.isLoading=true;
          try {
              this.model.tanggal = moment(this.model.tanggal).format('YYYY-MM-DD');
              this.reportUrl= await bakerydo.print(this.model);
              this.showReport=true;
              this.isLoading=false;
          } catch (error) {
                this.isLoading=false;            
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },  
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await bakerydo.exportxls(this.tblData);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Customerdelivery_list.xlsx');
            document.body.appendChild(link);
            link.click();

            this.isLoading=false;    
        } catch (error) {
                this.isLoading=false;            
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
        }
    },
    closeFrm(){
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
